import { FC, ReactNode, ReactElement, ButtonHTMLAttributes } from 'react';

interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
    children: ReactNode;
    variant?: 'primary' | 'secondary';
    onClick?: () => void;
    className?: string;
}

const Button: FC<ButtonProps> = ({
    children,
    variant = 'primary',
    onClick,
    className = '',
    ...props
}): ReactElement => {
    const baseStyles = "rounded-md py-2 text-xs font-medium transition-colors";

    // Define variant styles
    const variants = {
        primary: "bg-[#1A6FE5] text-white disabled:bg-gray-200 disabled:text-gray-400 disabled:cursor-not-allowed disabled:hover:bg-gray-200",
        secondary: "bg-white border border-[#ADCEFA] text-gray-900 hover:bg-gray-50 disabled:bg-gray-100 disabled:text-gray-400 disabled:cursor-not-allowed"
    };

    const variantClasses = variants[variant] || variants.primary;

    return (
        <button
            onClick={onClick}
            className={`${baseStyles} ${variantClasses} ${className}`}
            {...props}
        >
            {children}
        </button>
    );
};

export default Button;
